import { authApi } from "./authApi";
import { toastError } from "@/components/custom/Toast";
import router from "@/router";
import store from "@/store";

export const service = {
  postFun,
  postAuthFun,
  getFun,
  convertToFormData,
  deleteNullValues,
  deleteFun,
};

function deleteNullValues(data) {
  let filteredData = Object.entries(data).filter(
    ([key, value]) =>
      value !== undefined && value !== null && key !== null && value !== ""
  );
  return Object.fromEntries(filteredData);
}

function convertToFormData(data) {
  const newData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    console.log(key, value);
    newData.append(key, value);
  }
  console.dir(newData);
  return newData;
}
async function postFun(data, endPoint, options = null, refreshAction) {
  try {
    const response = await authApi.post(endPoint, data, options);
    const handledResponse = await handleResponseFun(response);
    if (!refreshAction) {
      return handledResponse;
    }
    if (data) {
      console.log(data, "dataa");
      if (data.EMPLOYEE) {
        store.dispatch(refreshAction.action, {
          page: store.state.page.page,
          EMPLOYEE: data.EMPLOYEE,
        });
      } else if (data.EMPSHIFT) {
        store.dispatch(refreshAction.action, {
          page: store.state.page.page,
          id: data.EMPSHIFT,
        });
      } else if (data.SHIFTID) {
        store.dispatch(refreshAction.action, {
          page: store.state.page.page,
          id: data.SHIFTID,
        });
      } else if (data.EMPRPTYPE) {
        console.log(data, "EMPRPTYPE");
        store.dispatch(refreshAction.action, {
          page: store.state.page.page,
          rpType: data.EMPRPTYPE,
        });
      } else if (data.country_id) {
        console.log(data, "country data");
        store.dispatch(refreshAction.action, {
          page: store.state.page.page,
          country_id: data.country_id,
        });
      } else {
        store.dispatch(refreshAction.action, {
          page: store.state.page.page,
        });
      }
    } else {
      store.dispatch(refreshAction.action, { page: store.state.page.page });
    }

    return handledResponse;
  } catch (error) {
    handleFailedResponse(error);
  }
}

async function postAuthFun(data, endPoint, options = null, refreshAction) {
  try {
    const response = await authApi.post(endPoint, data, options);
    const handledResponse = await handleResponseFun(response);
    if (data) {
      refreshAction.actions.forEach((action) => {
        store.dispatch(action, { page: store.state.page.page });
      });
      store.dispatch("setLoading", false);
      router.push("/home");
      return handledResponse;
    }
  } catch (error) {
    handleFailedResponse(error);
  }
}

async function getFun(endPoint) {
  try {
    const response = await authApi.get(endPoint);
    console.log("api response", response);
    const handledResponse = handleResponseFun(response);
    return handledResponse;
  } catch (error) {
    return handleFailedResponse(error);
  }
}
async function deleteFun(endPoint, refreshAction) {
  try {
    const response = await authApi.delete(endPoint);
    const handledResponse = handleResponseFun(response);
    if (!refreshAction) {
      return handledResponse;
    } else if (refreshAction.EMPRPTYPE) {
      store.dispatch(refreshAction.action, {
        page: store.state.page.page,
        rpType: refreshAction.EMPRPTYPE,
      });
    } else if (refreshAction.COUNTRY) {
      store.dispatch(refreshAction.action, {
        country_id: refreshAction.COUNTRY,
      });
    } else {
      store.dispatch(refreshAction.action, {
        page: store.state.page.page,
      });
    }
    return handledResponse;
  } catch (error) {
    handleFailedResponse(error);
  }
}
export function handleResponseFun(response) {
  if (!response.data.success) {
    return toastError(response.data.message);
  }
  switch (response.data.status_code) {
    case 200: {
      return deleteNullValues(response.data);
    }
    case 201: {
      return deleteNullValues(response.data);
    }
    case 202: {
      return deleteNullValues(response.data);
    }
  }
}

export function handleFailedResponse(error) {
  console.log(error, "this is error");
  if (error.code == "ERR_NETWORK") {
    return toastError(error.message);
  } else {
    switch (error.status_code || error.response.status) {
      case 400: {
        return toastError(error.response.data.message);
      }
      case 401: {
        return router.replace("/");
      }
      case 403: {
        let authError = error.response.data.errors[0].email[0];
        if (!authError) {
          authError = "Some thing went wrong";
        }
        return toastError(authError);
      }
      case 404: {
        return router.push("/ErrorNotFound");
      }
      case 405: {
        return toastError(error.response.data.message);
      }
      case 422: {
        return toastError(error.response.data.errors[0]);
      }
      case 500: {
        return toastError(error.response.message);
      }
    }
  }
}
